import React, { PropsWithChildren, useEffect } from "react";
import View from "@mui/material/Box"; //rename for portability to React Native
import { useCompleteProfileStyles } from "hooks/useCompleteProfileStyles";

type CompleteProfileContainerProps = {
    rootContainerClass: string;
    style?: React.CSSProperties | undefined;
    hasDarkClass?: boolean;
};

export const CompleteProfileContainer = ({
    children,
    rootContainerClass,
    style,
    hasDarkClass = true,
}: PropsWithChildren<CompleteProfileContainerProps>) => {
    const classes = useCompleteProfileStyles();

    // workaround to prevent iphone 13 have screen height moved by keyboard
    useEffect(() => {
        if (classes.safariAgent) {
            window.scrollTo(0, 0);
        }
    }, [classes.safariAgent]);
    return (
        <View
            className={`complete-profile-background ${rootContainerClass} ${hasDarkClass ? "dark-background" : ""}`}
            style={style}>
            <View className={classes.container}>{children}</View>
        </View>
    );
};
